import { z } from 'zod';
import { LOCATION_GROUP_CONSTRAINTS } from './constraints.js';
export const locationGroupNameSchema = z
    .string()
    .trim()
    .min(1, `${LOCATION_GROUP_CONSTRAINTS.name.label} is required`)
    .max(LOCATION_GROUP_CONSTRAINTS.name.maxLength, `${LOCATION_GROUP_CONSTRAINTS.name.label} must be ${LOCATION_GROUP_CONSTRAINTS.name.maxLength} characters or fewer`);
//# sourceMappingURL=create-form.js.map